export const DEV_SETTINGS={LOG_BQ_TRACKING_POINTS:"logBigQueryTrackingPoints"};export const DEV_SETTINGS_LOCAL_STORAGE_KEY="dev_settings";